export default "__VITE_ASSET__BX7bWfT2__"